<template>
  <div class="wrapper">
    <div class="container details">
      <div class="row"><div class="col-md-10"><h1>Statistik</h1></div></div>
      <div class="row" style="margin-top: 30px;width:1170px;max-width:100%">
        <div class="col-md-2">
          <label>Kund</label><br/>
          <AutoComplete id="complete" v-model="selectedCustomer" placeholder="Sök efter kund..." :suggestions="filteredCustomers" @complete="searchCustomer($event)" field="name">
            <template #item="slotProps">
              <div>{{slotProps.item.name}} ({{slotProps.item.id}})</div>
            </template>
          </AutoComplete>
        </div>
        <div class="col-md-2">
          <label for="startDate">Från</label><br/>
          <Calendar id="startDate" v-model="startDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="endDate">Till</label><br/>
          <Calendar id="endDate" v-model="endDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-1">
          <br/>
          <Button label="Sök" @click="getOrders()" />
        </div>
        <div class="col-md-3">
          <br/>
          <export-excel v-if="this.hasStatsResults" :data= "json_data" :fields = "json_fields" worksheet = "Statistik" :name= excelFileName()>
            <button class="p-button p-button-success p-component p-button-text-icon-left"><span class="pi pi-external-link p-button-icon-left"></span> <span class="p-button-text p-c">Exportera</span></button>
          </export-excel>
          <export-excel v-if="this.hasStatsAllResults" :data= "json_data" :fields = "json_fields" worksheet = "Statistik" :name= excelFileNameForAll()>
            <button class="p-button p-button-success p-component p-button-text-icon-left"><span class="pi pi-external-link p-button-icon-left"></span> <span class="p-button-text p-c">Exportera alla ordrar</span></button>
          </export-excel>
          <Button v-if="(this.hasStatsResults === false && this.hasStatsAllResults === false)" label="Generera export av alla ordrar" icon="pi pi-external-link" @click="getAllOrders()" />
        </div>
        <div class="col-md-1">
          <br/>
          <ProgressSpinner style="width:40px;height:40px" v-if="isWaiting" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <label><span v-if="selectedCustomer">{{customerName}}</span></label>
        </div>
      </div>
      <div class="row">
        <div v-if="this.hasStatsResults" class="col-md-6">
          <div class="statsTables" v-for="place in orderedPlaces" style="margin-bottom: 15px" :key="place.id">
            <strong>{{place.name}}</strong>
            <DataTable :value="place.orders">
              <Column header="Datum" headerStyle="width:6rem">
                <template #body="slotProps" >{{getDate(slotProps.data.date)}}</template>
              </Column>
              <Column field="id" header="Orderid" headerStyle="width:6rem"></Column>
              <Column header="Artikel" headerStyle="width:6rem">
                <template #body="slotProps">{{setArticleName(slotProps.data.article)}}</template>
              </Column>
              <Column field="amount" headerStyle="width:6rem" bodyStyle="text-align: center" header="Ton">
               <template #footer>
                    <strong>{{getTotalAmount(place)}}</strong> ton
              </template>
              </Column>
              <Column field="wait" bodyStyle="text-align: center" header="Väntetid" headerStyle="width:6rem"></Column>
              <Column bodyStyle="font-size: 11px;text-align: center" header="Kommentar">
                <template #body="slotProps" >{{slotProps.data.comment}} <span v-if="slotProps.data.unannounced"><strong>Oaviserad</strong></span></template>
              </Column>
              <Column field="hasReadInstructions" bodyStyle="text-align: center" header="Lästa instruktioner" headerStyle="width:6rem">
                <template #body="slotProps" ><span class="ml-1" title="Har läst instruktionerna" v-if="slotProps.data.hasReadInstructions == true"><i class='pi pi-check'></i></span></template>
              </Column>
            </DataTable>
          </div>
        </div>
        <div class="col-md-6">
          <div class="statsTables" v-for="article in orderedArticles" style="margin-bottom: 15px" :key="article.id">
            <strong>{{setArticleName(article.name)}}</strong>
            <DataTable :value="article.orders" >
              <Column header="Datum" headerStyle="width:6rem">
                <template #body="slotProps" >{{getDate(slotProps.data.date)}}</template>
              </Column>
              <Column field="id" header="Orderid" headerStyle="width:6rem"></Column>
              <Column field="amount" bodyStyle="text-align: center" header="Ton" headerStyle="width:7rem">
                <template #footer>
                  <strong>{{getTotalAmountArt(article)}}</strong> ton
              </template>
              </Column>
              <Column field="totalDel" header="Lossningar" bodyStyle="text-align: center">
                <template #footer>
                  <strong>{{getTotalDel(article)}}</strong>
              </template>
              </Column>
              <Column field="unannounced" bodyStyle="text-align: center" header="Varav oaviserad">
                <template #footer>
                  <strong>{{getTotalUnAnnounced(article)}}</strong> st
              </template>
              </Column>
              <Column field="wait" bodyStyle="text-align: center" header="Väntetid">
                <template #footer>
                  <strong>{{getTotalWait(article)}}</strong>
                </template>
              </Column>
              <Column field="comment" bodyStyle="font-size: 11px" header="Komm."></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import AutoComplete from 'primevue/autocomplete'
import Button from 'primevue/button'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Excel from 'vue-excel-export'
import ProgressSpinner from 'primevue/progressspinner'
export default {
  name: 'Feralcostats',
  components: {
    DataTable,
    Column,
    AutoComplete,
    Button,
    moment,
    ColumnGroup,
    Calendar,
    Row,
    Excel,
    ProgressSpinner
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      orders: [],
      customerPlaces: [],
      selectedCustomer: null,
      filteredCustomers: null,
      userCustomerId: null,
      hasStatsResults: false,
      hasStatsAllResults: false,
      isWaiting: false,
      customerName: '',
      places: [],
      articles: [],
      articleNames: [],
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      },
      json_fields: {
        'Id': 'id',
        'Kund': 'customerName',
        'Leveransställe': 'customer',
        'Ort': 'customerPlaceCity',
        'Postnummer': 'customerPlacePostal',
        'Datum': 'date',
        'Orderid': 'orderid',
        'Artikel': 'article',
        'Ton': 'ton'
      },
      json_data: [],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ]
    }
  },
  async mounted () {
    let today = new Date()
    this.endDate = new Date()
    let oneYearBack = new Date(today.setDate(today.getDate() - 365))
    this.startDate = oneYearBack
    this.articleNames = await this.getArticles()
    if (localStorage.getItem('userCustomerId') !== null) {
      this.userCustomerId = localStorage.getItem('userCustomerId')
    }
    this.customerPlaces = await this.getCustomerPlaces()
  },
  computed: {
    orderedPlaces: function () {
      return this._.orderBy(this.places, 'name')
    },
    orderedArticles: function () {
      return this._.orderBy(this.articles, 'name')
    }
  },
  watch: {
    orders: function (newVal, oldVal) {
      this.orders = newVal
    },
    places: function (newVal, oldVal) {
      this.places = newVal
    },
    articles: function (newVal, oldVal) {
      this.articles = newVal
    }
  },
  methods: {
    async getCustomerPlaces () {
      let response = await this.$http.get('/api/customersplaces')
      return response.data.customersplace
    },
    async getArticles () {
      let response = await this.$http.get('/api/objectdatas/objectdescriptionid/18')
      const articles = []
      for (let article of response.data) {
        articles.push({id: article.id, name: article.data.articleId, short: article.data.descr})
      }
      return articles
    },
    setArticleName (article) {
      const name = this.articleNames.filter(obj => {
        return obj.name === article
      })
      if (name) {
        if (name[0].name.startsWith('VET')) {
          return 'Vetlanda ' + name[0].short
        } else if (name[0].name.startsWith('SOL')) {
          return 'Sölvesborg ' + name[0].short
        }
        return name[0].short
      }
    },
    async searchCustomer (event) {
      this.places = null
      this.articles = null
      let callApi = '/api/customerplaces/search/' + event.query + '/' + this.userCustomerId
      await this.$http
        .get(callApi)
        .then(response => {
          this.filteredCustomers = response.data.map((el) => ({id: el.data.slutkundnr, name: el.data.slutkundnamn}))
          this.filteredCustomers = this.filteredCustomers.filter((value, index, self) => self.map(x => x.id).indexOf(value.id) === index)
        })
        .catch(error => console.log(error))
    },
    async getOrders () {
      if (this.selectedCustomer) {
        this.$forceUpdate()
        let startDate = moment(this.startDate).format('YYYY-MM-DD')
        let endDate = moment(this.endDate).format('YYYY-MM-DD')
        let callApi = '/api/orders/by-delivery/' + this.selectedCustomer.id + '/between/' + startDate + '/' + endDate
        await this.$http
          .get(callApi)
          .then(response => {
            let concatOrders = []
            for (let order of response.data) {
              let newOrders = []
              for (let action of order.data.orderRows[0].actions) {
                let orderObj = {id: null, name: null, amount: null, date: null, article: order.data.ItemId, wait: null, comment: null, extra: 0, unannounced: null, hasReadInstructions: null}
                let totalHours = 0
                let totalMins = 0
                let totalComments = ''
                if (action.name === 'Lossar') {
                  let city = ''
                  let customerPlaceId = null
                  for (let customerPlace of order.data.CustomerPlaces) {
                    if (customerPlace.id.toString() === action.deliveryPlaceId) {
                      city = customerPlace.name
                      customerPlaceId = customerPlace.id
                    }
                  }
                  orderObj.id = order.data.SalesId
                  orderObj.customerPlaceId = customerPlaceId
                  orderObj.name = city
                  orderObj.amount = action.amount
                  orderObj.date = action.endTime
                  orderObj.hasReadInstructions = action.hasReadInstructions === true ? true : ''
                  if (action.unAnnounced === true) {
                    orderObj.unannounced = 1
                  } else {
                    orderObj.unannounced = 0
                  }
                  for (let action2 of order.data.orderRows[0].actions) {
                    if (action2.name === 'Väntetid') {
                      const wait = (moment(action2.endTime).diff(moment(action2.startTime)))
                      let mins = Math.floor(moment.duration(wait).asMinutes())
                      totalMins = totalMins + mins
                    }
                    totalComments = totalComments + action2.comment + ' '
                  }

                  totalHours = Math.floor(totalMins / 60)
                  totalMins = Math.floor(totalMins - totalHours * 60)
                  if (totalMins.toString().length < 2) {
                    totalMins = '0' + totalMins
                  }
                  orderObj.wait = totalHours + ':' + totalMins
                  orderObj.comment = totalComments

                  let compareDate = moment(orderObj.date)
                  let isValid = compareDate.isBetween(moment(this.startDate), moment(this.endDate))
                  if (isValid) {
                    newOrders.push(orderObj)
                  }
                }
              }
              for (let currOrder of newOrders) {
                concatOrders.push(currOrder)
              }
            }
            let places = []
            for (let order of concatOrders) {
              if (places.length > 0) {
                let currentPlace = places.find(e => e.id === order.customerPlaceId)
                if (currentPlace !== undefined) {
                  currentPlace.name = order.name
                  currentPlace.orders.push(order)
                } else {
                  let orders = []
                  orders.push(order)
                  let customerPlace = this.customerPlaces.find(e => e.id === order.customerPlaceId)
                  if (customerPlace !== undefined) {
                    places.push({id: order.customerPlaceId, customerPlaceCity: customerPlace.data.art_benamning, customerPlacePostal: customerPlace.data.postal, name: order.name, orders})
                  } else {
                    console.log(order)
                  }
                }
              } else {
                let orders = []
                orders.push(order)
                let customerPlace = this.customerPlaces.find(e => e.id === order.customerPlaceId)
                places.push({id: order.customerPlaceId, customerPlaceCity: customerPlace.data.art_benamning, customerPlacePostal: customerPlace.data.postal, name: order.name, orders})
              }
            }
            this.places = places

            let articles = []
            for (let order of concatOrders) {
              if (articles.length > 0) {
                let currentArticle = articles.find(e => e.name === order.article)
                if (currentArticle !== undefined) {
                  currentArticle.orders.push(order)
                } else {
                  let orders = []
                  orders.push(order)
                  articles.push({name: order.article, orders})
                }
              } else {
                let orders = []
                orders.push(order)
                articles.push({name: order.article, orders})
              }
            }
            for (let article of articles) {
              const newOrders = []
              for (let order of article.orders) {
                let alreadyAdded = newOrders.find(e => e.id === order.id)
                if (!alreadyAdded) {
                  let groupedOrders = article.orders.filter(e => e.id === order.id)
                  let newOrder = {date: null, id: null, amount: 0, totalDel: 0, extra: 0, unannounced: 0, wait: '', comment: ''}
                  let amount = 0
                  let totalDel = 0
                  let totalUnAnnounced = 0
                  let totalComments = ''
                  let totalH = 0
                  let totalM = 0
                  for (let groupedOrder of groupedOrders) {
                    amount = amount + parseFloat(groupedOrder.amount)
                    totalDel = totalDel + 1
                    totalUnAnnounced = totalUnAnnounced + groupedOrder.unannounced
                    if (groupedOrder.comment && !totalComments.includes(groupedOrder.comment)) {
                      totalComments = totalComments + ' ' + groupedOrder.comment
                    }
                  }
                  newOrder.date = groupedOrders[0].date
                  newOrder.id = groupedOrders[0].id
                  newOrder.amount = amount.toFixed(2)
                  newOrder.totalDel = totalDel
                  newOrder.extra = groupedOrders[0].extra
                  if (totalM.toString().length === 1) {
                    totalM = '0' + totalM.toString()
                  }
                  let totalTime = totalH + ':' + totalM
                  if (totalTime !== '0:00') {
                    // newOrder.wait = totalTime
                  }
                  newOrder.wait = groupedOrders[0].wait
                  newOrder.unannounced = totalUnAnnounced
                  if (totalComments !== '') {
                    newOrder.comment = totalComments
                  }
                  newOrders.push(newOrder)
                }
              }
              article.orders = newOrders
            }
            this.articles = articles
            this.hasStatsResults = true
            this.hasStatsAllResults = false
            this.exportToExcel()
          })
          .catch(error => console.log(error))
      }
    },
    async getAllOrders () {
      this.isWaiting = true
      this.$forceUpdate()
      let startDate = moment(this.startDate).format('YYYY-MM-DD')
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      let callApi = '/api/orders/by-delivery-all/between/' + startDate + '/' + endDate
      await this.$http
        .get(callApi)
        .then(response => {
          let concatOrders = []
          for (let order of response.data) {
            let newOrders = []
            for (let action of order.data.orderRows[0].actions) {
              let orderObj = {id: null, name: null, amount: null, date: null, article: order.data.ItemId, wait: null, comment: null, extra: 0, unannounced: null}
              let totalHours = 0
              let totalMins = 0
              let totalComments = ''
              if (action.name === 'Lossar') {
                let city = ''
                let customerPlaceId = null
                for (let customerPlace of order.data.CustomerPlaces) {
                  if (customerPlace.id.toString() === action.deliveryPlaceId) {
                    city = customerPlace.name
                    customerPlaceId = customerPlace.id
                  }
                }
                orderObj.id = order.data.SalesId
                orderObj.customerPlaceId = customerPlaceId
                orderObj.name = city
                orderObj.amount = action.amount
                orderObj.date = action.endTime
                if (action.unAnnounced === true) {
                  orderObj.unannounced = 1
                } else {
                  orderObj.unannounced = 0
                }
                for (let action2 of order.data.orderRows[0].actions) {
                  if (action2.name === 'Väntetid') {
                    const wait = (moment(action2.endTime).diff(moment(action2.startTime)))
                    let mins = Math.floor(moment.duration(wait).asMinutes())
                    totalMins = totalMins + mins
                  }
                  totalComments = totalComments + action2.comment + ' '
                }

                totalHours = Math.floor(totalMins / 60)
                totalMins = Math.floor(totalMins - totalHours * 60)
                if (totalMins.toString().length < 2) {
                  totalMins = '0' + totalMins
                }
                orderObj.wait = totalHours + ':' + totalMins
                orderObj.comment = totalComments

                let compareDate = moment(orderObj.date)
                let isValid = compareDate.isBetween(moment(this.startDate), moment(this.endDate))
                if (isValid) {
                  newOrders.push(orderObj)
                }
              }
            }
            for (let currOrder of newOrders) {
              concatOrders.push(currOrder)
            }
          }
          let places = []
          for (let order of concatOrders) {
            if (places.length > 0) {
              let currentPlace = places.find(e => e.name === order.name)
              if (currentPlace !== undefined) {
                currentPlace.orders.push(order)
              } else {
                let orders = []
                orders.push(order)
                let customerPlace = this.customerPlaces.find(e => e.id === order.customerPlaceId)
                if (customerPlace) {
                  places.push({id: order.customerPlaceId, endCustomerName: customerPlace.data.slutkundnamn, customerPlaceCity: customerPlace.data.art_benamning, customerPlacePostal: customerPlace.data.postal, name: order.name, orders})
                }
              }
            } else {
              let orders = []
              orders.push(order)
              let customerPlace = this.customerPlaces.find(e => e.id === order.customerPlaceId)
              if (customerPlace) {
                places.push({id: order.customerPlaceId, endCustomerName: customerPlace.data.slutkundnamn, customerPlaceCity: customerPlace.data.art_benamning, customerPlacePostal: customerPlace.data.postal, name: order.name, orders})
              }
            }
          }
          this.places = places
          this.hasStatsResults = false
          this.hasStatsAllResults = true
          this.isWaiting = false
          this.exportToExcel()
        })
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).utc().format('YYYY-MM-DD')
      return formattedDate
    },
    getTotalAmount (place) {
      let totalAmount = 0.00
      let newPlace = this.orderedPlaces.filter(obj => {
        return obj.name === place.name
      })
      for (let order of newPlace[0].orders) {
        totalAmount = parseFloat(totalAmount) + parseFloat(order.amount)
      }
      return totalAmount.toFixed(2)
    },
    getTotalAmountArt (article) {
      let totalAmount = 0.00
      let newArticle = this.orderedArticles.filter(obj => {
        return obj.name === article.name
      })
      for (let order of newArticle[0].orders) {
        totalAmount = parseFloat(totalAmount) + parseFloat(order.amount)
      }
      return totalAmount.toFixed(2)
    },
    getTotalDel (article) {
      let totalAmount = 0
      for (let order of article.orders) {
        totalAmount = totalAmount + order.totalDel
      }
      return totalAmount + ' st'
    },
    getTotalUnAnnounced (article) {
      let totalAmount = 0
      for (let order of article.orders) {
        totalAmount = parseFloat(totalAmount) + parseFloat(order.unannounced)
      }
      return totalAmount
    },
    getTotalExtra (article) {
      let totalAmount = 0
      for (let order of article.orders) {
        totalAmount = parseFloat(totalAmount) + parseFloat(order.extra)
      }
      return totalAmount
    },
    getTotalWait (article) {
      let totalH = 0
      let totalM = 0
      for (let order of article.orders) {
        if (order.wait) {
          let time = order.wait.split(':')
          let h = parseInt(time[0])
          let m = parseInt(time[1])
          totalH = totalH + h
          totalM = totalM + m
        }
      }

      if (totalM.toString().length === 1) {
        totalM = '0' + totalM.toString()
      }
      let totalTime = totalH + ':' + totalM

      if (totalTime !== '0:00') {
        return totalTime
      }
      return ''
    },
    excelFileName () {
      return this.selectedCustomer.name + ' ' + this.getDate(this.startDate) + '-' + this.getDate(this.endDate) + '.xls'
    },
    excelFileNameForAll () {
      return 'Alla ordrar ' + this.getDate(this.startDate) + '-' + this.getDate(this.endDate) + '.xls'
    },
    exportToExcel () {
      for (let place of this.places) {
        for (let order of place.orders) {
          let newRow = {id: place.id, customerName: place.endCustomerName, customer: place.name, customerPlaceCity: place.customerPlaceCity, customerPlacePostal: place.customerPlacePostal, date: this.getDate(order.date), orderid: order.id, article: order.article, ton: order.amount}
          this.json_data.push(newRow)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/FeralcoStats.vue